import styled, { css } from 'styled-components';

import {
  rgba,
} from 'polished';

import {
  colors,
  layers,
  layout,
  typography
} from '../../theme';

import {
  Inset,
  HeadingOne,
} from '../../elements';

export const Wrapper = styled.div`
  background: ${colors.WHITE};
  margin-bottom: 100vh;
  overflow: visible;
  position: relative;
  z-index: ${layers.BODY};
  padding-bottom: ${160 / typography.BASE_FONT_SIZE}rem;
  width: 100%;
  -webkit-backface-visibility: hidden;

  @media all and (max-width: 1023px) and (min-width: 667px) {
    padding-bottom: ${80 / typography.BASE_FONT_SIZE}rem;
  }
  @media screen and (max-width: 666px) {
    padding-top: ${30 / typography.BASE_FONT_SIZE}rem;
  }
`;

export const Section = styled.section`

  ${(props) => props.name === 'Introduction' && css`
    padding-top: ${200 / typography.BASE_FONT_SIZE}rem;

    @media all and (max-width: 1023px) and (min-width: 667px) {
      padding-top: ${95 / typography.BASE_FONT_SIZE}rem;
    }

    @media screen and (max-width: 666px) {
      padding-top: ${50 / typography.BASE_FONT_SIZE}rem;
    }
  `}
`;

export const HeadingOneSpecial = HeadingOne.extend`
  padding-left: ${100 / typography.BASE_FONT_SIZE}rem;
  padding-right: ${100 / typography.BASE_FONT_SIZE}rem;
  @media all and (max-width: 1023px) and (min-width: 667px) {
    padding-left: ${180 / typography.BASE_FONT_SIZE}rem;
    padding-right: ${180 / typography.BASE_FONT_SIZE}rem;
  }
  @media screen and (max-width: 666px) {
    padding-left: ${20 / typography.BASE_FONT_SIZE}rem;
    padding-right: ${20 / typography.BASE_FONT_SIZE}rem;
  }
`;

export const SpecialInset = Inset.extend`
  margin-bottom: ${50 / typography.BASE_FONT_SIZE}rem;
  @media all and (max-width: 1023px) and (min-width: 667px) {
    margin-bottom: ${0 / typography.BASE_FONT_SIZE}rem;
  }
  @media screen and (max-width: 666px) {
    margin-bottom: ${20 / typography.BASE_FONT_SIZE}rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Body/style.js